var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="filter-area-item bulk-actions-control">\n  <div class="dropdown">\n    <button class="btn btn-default dropdown-toggle disabled" type="button" data-toggle="dropdown" aria-expanded="true" disabled="true">\n      Bulk Actions\n      <span class="caret"></span>\n    </button>\n    <ul class="dropdown-menu dropdown-menu-right" role="menu">\n      ';
 _.each(actions, function(config) { 
__p+='\n        ';
 var actionName = _.result(config, "text") 
__p+='\n        <li role="presentation">\n          <a role="menuitem" tabindex="-1" href="#" data-action-name="'+
((__t=( actionName ))==null?'':__t)+
'">\n            '+
((__t=( _.escape(actionName) ))==null?'':__t)+
'\n          </a>\n        </li>\n      ';
 }) 
__p+='\n    </ul>\n  </div>\n</div>\n';
}
return __p;
};
